export default __webpack_public_path__ + "static/media/Strangler's Gloves of the Black Arts.66bac396.jpg";